import React from "react";
import ModalVideoLauncherCard from "../components/ModalVideoLauncherCard";

export function renderMarketingTestimonial(videoModal) {
    const videoTestimonialProps = {
        videoModal: videoModal,
        videoSource: "https://player.vimeo.com/video/378881542?autoplay=1&title=0&byline=0",
        videoPreviewImageSource: require("../assets/redesign2020/marketing-video-testimonial/anderson.png"),
        videoGoogleAnalyticsName: "clientStories",
        logoProps: {
            altText: "Andersen Tax",
            source: require("../assets/redesign2020/marketing-video-testimonial/anderson-logo.png")
        },
        textBodyProps: {
            textBodyHeader: <React.Fragment>Why Andersen Tax <span className="highlighted">invests in their people</span>.</React.Fragment>,
            textBodyContent: <React.Fragment>Andersen Tax wanted to provide a relevant benefit for their employees in hopes of easing their student debt burden. Launching a Student Loan PayDown program spoke volumes to their workforce and is a component of what they strive to build culturally.</React.Fragment>
        }
    };
    return (
        <ModalVideoLauncherCard {...videoTestimonialProps} />
    );
}

export function renderMSAtWorkVideoCard(videoModal) {
    const msAtWorkVideoProps = {
        videoModal: videoModal,
        videoSource: "https://player.vimeo.com/video/507676807?autoplay=1&title=0&byline=0",
        videoPreviewImageSource: require("../assets/home/msaw-placeholder.jpg"),
        videoGoogleAnalyticsName: "msAtWork",
        logoProps: null,
        textBodyProps: {
            textBodyHeader: <React.Fragment>Gradifi by <span className="solutions-etrade-logo">E<img className="solutions-etrade-icon-large" alt="ETRADE Logo" src={require("../assets/redesign2020/etrade-icon.svg")} />TRADE</span> <span className="highlighted"> is part of the Morgan Stanley at Work suite of solutions.</span></React.Fragment>,
            textBodyContent: <React.Fragment>Innovative workplace offerings for companies and employees across Equity Compensation, Financial Wellness, and Retirement Solutions and service offerings to support the full spectrum of wealth.</React.Fragment>
        }
    };
    return (
        <ModalVideoLauncherCard {...msAtWorkVideoProps} />
    );
}